<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-form ref="form" v-model="valid">
          <v-card-title class="pb-5">
            <v-icon color="success">mdi-plus</v-icon>
            <span class="headline ml-5">{{ $t("create_new_blog_post") }}</span>
          </v-card-title>
          <v-card-text class="mt-5">

            <v-text-field
              dense
              outlined
              required
              :rules="requiredRule"
              :label="$t('post_title')"
              v-model="post.title"
            ></v-text-field>

            <v-textarea
              outlined
              auto-grow
              :label="$t('post_text')"
              v-model="post.text"
              counter
            >
            </v-textarea>

            <div>
              <v-text-field
                v-for="(val, key, i) in post.social_media"
                :key="i"
                outlined
                :label="$t(key)"
                v-model="post.social_media[key]"
                dense
              >
                <template v-slot:prepend>
                  <v-icon :color="config.icons.social_media[key].color">{{
                    config.icons.social_media[key].icon
                  }}</v-icon>
                </template></v-text-field
              >
            </div>
          </v-card-text>
         
          <v-card-actions class="pa-5">
            <CloseButton @click.native="close()" />
            <v-spacer></v-spacer>
            <div>
              <SaveButton
                :disabled="!valid || loading"
                @click.native="update()"
              />
            </div>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import CloseButton from "@/components/small/CloseButton";
import SaveButton from "@/components/small/SaveButton";
// import Info from "@/components/small/Info";
export default {
  components: {
    // Info,
    SaveButton,
    CloseButton,
  },
  props: ['post'],
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      requiredRule: [(v) => !!v || this.$t("field_required")],
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
    config() {
      return this.$store.getters["config/getConfig"];
    },
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
   
    async update() {
      try {
        if (this.$refs.form.validate()) {
          this.loading = true;
          await this.$store.dispatch("blogPost/updateBlogPost", this.post);
          this.loading = false;
          this.close();
        }
      } catch (error) {
        this.loading = false;
      }
    },
    open() {
      this.dialog = true;
    },
    close() {
      // this.reset();
      // this.resetValidation();
      this.dialog = false;
    },
  },
};
</script>

<style>
</style>